import React from "react";
import { SettingsManagedPanel } from "../components/SettingsManagedPanel";
import { TeamTabsBoard } from "../components/TeamTabsBoard";
import { SettingsLayout } from "../layout/SettingsLayout";

/**
 * TeamAssignmentPage — `/settings/team-assignment`.
 *
 * The maker–checker board: the same six-module-tab screen master-admin runs
 * at onboarding, editing this tenant's live roles, review policies and
 * checker pools. It replaced the per-user card list (TeamMemberList, kept in
 * the tree but unrouted); the unseated-people section at the bottom of the
 * board absorbed that list's remaining job (stock role + deactivate).
 */
export const TeamAssignmentPage: React.FC = () => (
  <SettingsLayout>
    <SettingsManagedPanel
      title="Team assignment"
      description="Who works on each module tab, what needs review, and who checks it."
    >
      <TeamTabsBoard />
    </SettingsManagedPanel>
  </SettingsLayout>
);
